export enum ErrorTypeEnum {
  UnprocessableContent = 422,
}
